module.exports = __webpack_public_path__ + "img/beian.d0289dc0.jpg";